import BirdieImage from '@/assets/birdie.svg';

import styles from './index.module.css';

const Welcome = () => {
  return (
    <div className={styles.container}>
      <div className={styles['content-container']}>
        <div className={styles.container}></div>
      </div>
      <div className={styles['home-image']}>
        <BirdieImage />
      </div>
    </div>
  );
};

export default Welcome;
